import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from "../../../components/ui/card";
import { Button } from '../../../components/ui/button';
import { Users, Database, Upload, CircleUserRound } from 'lucide-react';
import { useSelector } from 'react-redux';


const Welcome = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.Auth);
    const adminOrSysdev = user?.role?.key === "ADM" || user?.role?.key === "SYSDEV";

    return (
        <Card className="bg-primary-gradient text-white p-6 flex flex-col lg:flex-row justify-between items-center rounded-xl">
            <div>
                <h1 className="text-2xl font-bold mb-2">Welcome {user?.name || "User"}</h1>
                <p className="mb-4 max-w-xl">
                    {adminOrSysdev ? 
                        'Manage your data uploads, user roles, and system configurations all from one central hub.' : 
                        'Manage your data uploads and review upload history from a single dashboard.'
                    }
                </p>
                <div className="flex flex-wrap gap-2">
                    {adminOrSysdev && <Button variant="outline" className="flex gap-2 items-center" onClick={() => navigate('/data-categories')}>
                        <Database size={16} /> Manage Data Categories
                    </Button>}
                    {adminOrSysdev && <Button variant="outline" className="flex gap-2 items-center" onClick={() => navigate('/vendors')}>
                        <CircleUserRound size={16} /> Manage Vendors
                    </Button>}
                    {adminOrSysdev && <Button variant="outline" className="flex gap-2 items-center" onClick={() => navigate('/users')}>
                        <Users size={16} /> Manage Users
                    </Button>}
                    <Button variant="outline" className="flex gap-2 items-center" onClick={() => navigate('/upload-history')}>
                        <Upload size={16} /> Upload History
                    </Button>
                </div>

            </div>
            <div className="h-[150px]">
                <img src="./welcome_3d_img.png" alt="Welcome Illustration" className="h-full object-contain" />
            </div>
        </Card>
    );
};

export default Welcome;
